export class DropTrigger {
    constructor() {
        this.initEventListener();
    }

    private initEventListener(): void {
        document.addEventListener('click', event => {
            let target = event.target as HTMLElement;

            if (! target.classList.contains('drop-trigger')) {
                // target kann auch ein span sein (z.B. im bestellprozess bei den optionen)
                const parent = target.parentElement;
                if(!parent || !parent.classList.contains('drop-trigger')) {
                    return;
                }
                target = parent;
            }

            event.preventDefault();
            event.stopImmediatePropagation();

            const container = target.parentElement;
            if (container) {
                container.classList.toggle('active');
            }
        })
    }
}
